import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Sessao } from '../modelo/sessao';
import { Config } from './config';

@Injectable()
export class SessaoService {

    sessao: Sessao;

    constructor(private http: HttpClient) {
        if(this.sessao == null){
            this.sessao = new Sessao();
        }

        if(sessionStorage.getItem("sessaoBF")){
            this.sessao = JSON.parse(sessionStorage.getItem("sessaoBF"));
        }
    }

    encerrarSessao = (nuCTRL:string): Observable<Sessao> => {
      return this.http.get<Sessao>(`${Config.LOGIN_PATH}/encerrarSessao/nuCTRL/${nuCTRL}`)
   };

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/sessao.service.ts